// Base content structure for input fields in reward points
const baseRewardPointContent = {
  type: "input",
  inputType: "number",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "generalSetting",
    file: {},
    isUpdated: false,
  },
  translation: { input: "", flag: false, isUpdated: false },
};

// Helper function to create a reward point entry
const createRewardPointEntry = (title: string, key: string, inputType: string, label: string, isRequired: boolean) => ({
  title,
  content: {
    ...baseRewardPointContent,
    inputType,
    label,
    data: {
      ...baseRewardPointContent.data,
      key,
    },
  },
  isRequired,
  readonly: false,
  isButton: false,
});

// Reward points entries
const rewardPointEntries = [
  { title: "Automatch Threshold", key: "activatingAutoMatchPoints", inputType: "number", label: "Please Enter Automatch Threshold", isRequired: true },
  { title: "Enter Survey Reward Cost", key: "surveyRewardCost", inputType: "number", label: "Please Enter Survey Reward Cost", isRequired: true },
  { title: "Que Content Points", key: "queContentPoints", inputType: "number", label: "Please Enter Que Content Points", isRequired: false },
  { title: "Enter Positive Reward Earned", key: "positiveRewardPoints", inputType: "number", label: "Please Enter Positive Reward Source", isRequired: true },
  { title: "Enter Positive Reward Popup Source", key: "positiveRewardPopUp", inputType: "text", label: "Please Enter Positive Reward Popup Source", isRequired: true },
  { title: "Enter Negative Reward Earned", key: "negativeRewardPoints", inputType: "number", label: "Please Enter Negative Reward Source", isRequired: true },
  { title: "Enter Negative Reward Popup Source", key: "negativeRewardPopUp", inputType: "text", label: "Please Enter Negative Reward Popup Source", isRequired: true },
  { title: "User Submitted Content Ad", key: "coinAwardUserSubmittedAd", inputType: "number", label: "Please Enter User Submitted Content Ad", isRequired: false },
  { title: "Coin Points", key: "coinRewardAmount", inputType: "number", label: "Please Enter Coin Points", isRequired: false },
  { title: "Save Points", key: "saveRewardAmount", inputType: "number", label: "Please Enter Save Points", isRequired: false },
];

// Generate reward points array
const rewardPoints = rewardPointEntries.map(({ title, key, inputType, label, isRequired }) =>
  createRewardPointEntry(title, key, inputType, label, isRequired)
);

export { rewardPoints };
